import React from 'react';
import cc from 'classcat';
import C from './SpaceCard.css';
import { useSpaceSummary } from 'atoms/spaces';
import FavoriteBorderIcon from '!!react-svg-loader!./icons/icon--star-unfilled.svg';
import FavoriteIcon from '!!react-svg-loader!./icons/icon--star-filled.svg';

export default function SpaceBookmarkControl(p: {
  spaceId: string;
  isSelfHosted?: boolean;
}) {
  const { space, toggleBookmark } = useSpaceSummary({
    spaceId: p.spaceId,
  });

  return (
    <div
      className={cc({
        [C.likeCount]: true,
      })}
      style={{
        cursor: p.isSelfHosted ? 'default' : 'pointer',
      }}
      onClick={
        p.isSelfHosted
          ? undefined
          : async (e) => {
              e.stopPropagation();
              e.preventDefault();
              toggleBookmark();
            }
      }
    >
      {space?.isBookmarked ? (
        <FavoriteIcon style={{ width: '1rem' }} />
      ) : (
        <FavoriteBorderIcon style={{ width: '1rem' }} />
      )}{' '}
      {space?.bookmarkCount}
    </div>
  );
}
